import React, {useState} from "react";
import {publishBlog} from '../Helpers/firebaseHelpers';
import Profile from './Profile';
import { useAuthUser } from './useAuthUser';

const WriteBlog = () => 
{
    const {userAuth , loading} = useAuthUser();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [currentView, setCurrentView] = useState('writing');
    
    const [Title, setTitle] = useState ({
        inputText: ''
    })

    const [BlogText, setBlogText] = useState ({
        BlogData: ''
    })

    const handlePublishBlog = async () =>
    {
        if (!Title.inputText.trim() || !BlogText.BlogData.trim())
        {
            alert("Please fill in all the fields");
            return;
        }

        setIsSubmitting(true);

        const blogPayload =
        {
            UserName: userAuth.displayName,
            BlogTitle: Title.inputText,
            BlogData: BlogText.BlogData
        };

        try
        {
            const result = await publishBlog (blogPayload);

            if (result.success)
            {
                alert("Blog published successfully! You'll see it in published section soon.");
                
                setTitle({inputText:''});
                setBlogText({BlogData:''});
                
                setCurrentView('profile');
            } else 
            {
                alert("Failed to publish the Blog, " + result.error);
            }
        } catch (error)
        {
            console.error("Error while submitting/publishing the blog : ",error);
            alert("An error occured while submitting/publishing your blog");
        }

        setIsSubmitting(false);
    }

    if (userAuth==null)
    {
        return <div className="ml-20 mt-20 text-4xl">
            Authorizing the user to write the blog.
        </div>
    }

    if (currentView === 'profile')
    {
        return <Profile />;
    }

    return (
        <div className="p-4 md:p-8 max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b pb-2">
                ✍️ Create New Blog Post
            </h2>
            <div className="space-y-6">
                
                {/* Blog Title Input */}
                <div>
                    <label 
                        htmlFor="blog-title" 
                        className="block text-sm font-medium text-gray-700 mb-2"
                    >
                        Blog Title
                    </label>
                    <input
                        id="blog-title"
                        type="text"
                        value={Title.inputText}
                        onChange={(e) => setTitle({...Title, inputText: e.target.value})}
                        placeholder="Enter the title of your post"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                        disabled={isSubmitting}
                    />
                </div>

                {/* Blog Content Textarea */}
                <div>
                    <label 
                        htmlFor="blog-content" 
                        className="block text-sm font-medium text-gray-700 mb-2"
                    >
                        Blog Content
                    </label>
                    <textarea
                        id="blog-content"
                        rows="15"
                        value={BlogText.BlogData}
                        onChange={(e) => setBlogText({...BlogText, BlogData: e.target.value})}
                        placeholder="Start writing your amazing content here..."
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 resize-y"
                        disabled={isSubmitting}
                    />
                </div>

                {/* Publish Button */}
                <button
                    onClick={handlePublishBlog}
                    disabled={isSubmitting}
                    className={`
                        w-full px-6 py-3 text-lg font-semibold rounded-lg transition duration-150 ease-in-out
                        ${isSubmitting 
                            ? 'bg-gray-400 cursor-not-allowed' 
                            : 'bg-indigo-600 hover:bg-indigo-700 text-white shadow-md'
                        }
                    `}
                >
                    {isSubmitting ? 'Publishing...' : 'Publish Blog Post'}
                </button>
                
                {/* Displaying User Info for context */}
                <div className="pt-4 text-lg text-black border-t mt-6">
                    Publishing as: {userAuth.displayName}
                </div>
            </div>
        </div>
    );
}

export default WriteBlog;